import { render } from "./NumberComponent.vue?vue&type=template&id=5afc3416&scoped=true"
import script from "./NumberComponent.vue?vue&type=script&lang=js"
export * from "./NumberComponent.vue?vue&type=script&lang=js"

import "./NumberComponent.vue?vue&type=style&index=0&id=5afc3416&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afc3416"]])

export default __exports__